export const container = "c17ho2lp";
export const imgStyles = "i1nz3239";
export const pictureStyles = "pzhmf6a";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");